import React, { useMemo } from 'react';
import { FaGithub, FaLinkedin, FaTwitter, FaReddit, FaDiscord, FaShieldAlt, FaTerminal } from 'react-icons/fa';
import { SiWechat } from 'react-icons/si';
import { allCommands } from '../data/cyberCommands';

const Footer = () => {
  const socials = [
    { icon: FaGithub, label: 'GitHub', url: 'https://github.com/ArapKBett' },
    { icon: FaLinkedin, label: 'LinkedIn', url: 'https://linkedin.com/in/kipkorir-bett-ba580a321' },
    { icon: FaTwitter, label: 'X', url: 'https://twitter.com/kp15_5' },
    { icon: FaReddit, label: 'Reddit', url: 'https://reddit.com/user/Waste_Explanation410' },
    { icon: FaDiscord, label: 'Discord', url: 'https://discord.com/users/Sharbc' },
    { icon: SiWechat, label: 'WeChat', url: 'weixin://dl/chat?AK_Bett' },
  ];

  const footerCommands = useMemo(() =>
    [...allCommands].sort(() => Math.random() - 0.5).slice(0, 30),
  []);

  return (
    <footer className="relative border-t border-cyber-green/10 bg-cyber-dark/80">
      <div className="h-px bg-gradient-to-r from-transparent via-cyber-green/50 to-transparent"></div>

      {/* Background commands in footer */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-[0.025]">
        <div className="font-mono text-[8px] text-cyber-green leading-relaxed p-4 columns-2 gap-8">
          {footerCommands.map((cmd, i) => (
            <div key={i} className="break-inside-avoid truncate">$ {cmd}</div>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <FaShieldAlt className="text-cyber-green text-xl" />
              <span className="text-cyber-green font-bold text-lg">ARAP<span className="text-cyber-cyan">BETT</span></span>
            </div>
            <p className="text-cyber-muted text-sm leading-relaxed">
              Cybersecurity Specialist crafting secure digital infrastructure.
              Defending networks, hunting threats, writing code.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="text-cyber-green text-sm font-semibold mb-4 flex items-center gap-2">
              <FaTerminal className="text-xs" /> NAVIGATION
            </h3>
            <div className="space-y-2">
              {['Home', 'Portfolio', 'Blog', 'Contact'].map((link) => (
                <a key={link} href={link === 'Home' ? '/' : `/${link.toLowerCase()}`}
                  className="block text-sm text-cyber-muted hover:text-cyber-green transition-colors">
                  <span className="text-cyber-green/40 mr-2">{'>'}</span>cd ~/{link.toLowerCase()}
                </a>
              ))}
            </div>
          </div>

          {/* Connect */}
          <div>
            <h3 className="text-cyber-green text-sm font-semibold mb-4">{'// CONNECT'}</h3>
            <div className="grid grid-cols-3 gap-3">
              {socials.map((social) => (
                <a key={social.label} href={social.url} target="_blank" rel="noopener noreferrer"
                  className="flex flex-col items-center gap-1 p-3 rounded-lg bg-cyber-panel/50 border border-transparent hover:border-cyber-green/30 hover:bg-cyber-green/5 transition-all group">
                  <social.icon className="text-cyber-muted group-hover:text-cyber-green transition-colors text-lg" />
                  <span className="text-xs text-cyber-muted group-hover:text-cyber-green transition-colors">{social.label}</span>
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-cyber-green/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-cyber-muted font-mono">
            <span className="text-cyber-green">$</span> echo "© 2025 Kipkorir Arap Bett. All rights reserved."
          </p>
          <div className="flex items-center gap-4 text-xs text-cyber-muted font-mono">
            <span><span className="text-cyber-green">●</span> Systems Operational</span>
            <span>|</span>
            <span>v2.0.0</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
